var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80484 11.5821L12.4663 5.92063L11.5789 5.03326L6.80484 9.80737L4.40484 7.40737L3.51747 8.29474L6.80484 11.5821ZM8.00147 16C6.89495 16 5.85488 15.79 4.88126 15.3701C3.90765 14.9502 3.06077 14.3803 2.34063 13.6604C1.62049 12.9406 1.05032 12.094 0.630105 11.1208C0.210035 10.1476 0 9.10786 0 8.00147C0 6.89495 0.209965 5.85488 0.629895 4.88126C1.04982 3.90765 1.61972 3.06077 2.33958 2.34063C3.05944 1.62049 3.90597 1.05032 4.87916 0.630105C5.85235 0.210035 6.89214 0 7.99853 0C9.10505 0 10.1451 0.209965 11.1187 0.629894C12.0924 1.04982 12.9392 1.61972 13.6594 2.33958C14.3795 3.05944 14.9497 3.90597 15.3699 4.87916C15.79 5.85235 16 6.89214 16 7.99853C16 9.10505 15.79 10.1451 15.3701 11.1187C14.9502 12.0924 14.3803 12.9392 13.6604 13.6594C12.9406 14.3795 12.094 14.9497 11.1208 15.3699C10.1476 15.79 9.10786 16 8.00147 16Z",
    fill: "#2C8C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.0be09cf2be4a46878ad22867155cfed5.svg";
export { ForwardRef as ReactComponent };